import moment from 'moment';
import { map } from 'lodash';

import { labelize } from 'buyside/util/arrayHelper';

import HorizontalBarIcon from 'buyside/svgs/horizontal_bar.svg';
import ThumbsDownIcon from 'buyside/svgs/thumbs_down.svg';
import ThumbsUpIcon from 'buyside/svgs/thumbs_up.svg';

import { IdeaAttachment, ResearchAttachmentAttributes } from 'interfaces/graphql-typings';

const {
  ideaAttachmentTypes,
  ideaUpdateTimeframes
} = require('buyside/util/constantsFromRails.json');

type OptionType = { value: string; label: string };
enum ImpactLabels {
  POSITIVE = 'positively',
  NEUTRAL = 'neutral',
  NEGATIVE = 'negatively'
}

export const createTimeFrameOptions = (createdAt: string): OptionType[] => {
  const monthsFromIdeaCreation = moment().diff(moment(new Date(createdAt)), 'months');
  return ideaUpdateTimeframes.reduce((memo: OptionType[], timeframe: string): OptionType[] => {
    if (timeframe === '< 3 Months' && monthsFromIdeaCreation < 3) {
      memo.push({ value: timeframe, label: timeframe });
    } else if (timeframe === '3-6 Months' && monthsFromIdeaCreation < 6) {
      memo.push({ value: timeframe, label: timeframe });
    } else if (timeframe === '6 Mo. - 1 Year' && monthsFromIdeaCreation < 12) {
      memo.push({ value: timeframe, label: timeframe });
    } else if (timeframe === '1-2 Years' && monthsFromIdeaCreation < 24) {
      memo.push({ value: timeframe, label: timeframe });
    } else if (timeframe === '2-5 Years' && monthsFromIdeaCreation < 60) {
      memo.push({ value: timeframe, label: timeframe });
    } else if (timeframe === '5-7 Years' && monthsFromIdeaCreation < 84) {
      memo.push({ value: timeframe, label: timeframe });
    } else if (timeframe === '7-10 Years' && monthsFromIdeaCreation < 120) {
      memo.push({ value: timeframe, label: timeframe });
    } else if (timeframe === '10-12 Years') {
      memo.push({ value: timeframe, label: timeframe });
    }
    return memo;
  }, []);
};

export const createAttachmentTypeOptions = (researchType: string): OptionType[] =>
  ideaAttachmentTypes[researchType] === undefined
    ? []
    : labelize(ideaAttachmentTypes[researchType], true);

export const formatAttachmentsArray = (
  attachments: IdeaAttachment[]
): ResearchAttachmentAttributes[] =>
  map(attachments, ({ id, attachmentType, filename, researchType }) => ({
    id,
    attachmentType,
    filename: filename || '',
    researchType
  }));

export enum ImpactValues {
  POSITIVE = 'positive',
  NEUTRAL = 'neutral',
  NEGATIVE = 'negative'
}

export const impactOptions = [
  {
    icon: ThumbsUpIcon,
    value: ImpactValues.POSITIVE,
    label: ImpactLabels.POSITIVE
  },
  {
    icon: HorizontalBarIcon,
    value: ImpactValues.NEUTRAL,
    label: ImpactLabels.NEUTRAL
  },
  {
    icon: ThumbsDownIcon,
    value: ImpactValues.NEGATIVE,
    label: ImpactLabels.NEGATIVE
  }
];
